import styled, { keyframes, css } from "styled-components";

export const Container = styled.div`
  position: relative;
  height: 100vh;
  max-height: 100vh;
  max-width: 100vw;
  transform: ${({ scale, translateY }) => `translateY(${translateY}%) scale(${scale})`};
  transition: transform 0.3s ease-in-out;
`;

export const Gashapon = styled.img`
  position: absolute;
  height: 80%;
  top: 50%; /* Centra verticalmente */
  left: 50%; /* Centra horizontalmente */
  transform: translate(-50%, -50%); /* Ajusta el centro del elemento */
`

// Definimos la animación de respiración
const breathe = keyframes`
  0% { filter: brightness(1.5); }
  50% { filter: brightness(1.8); }
  100% { filter: brightness(1.5); }
`;

export const Manilla = styled.img.attrs(({ angle }) => ({
  style: {
    transform: `translate(-50%, 25%) rotate(${angle}deg)`,
  },
}))`
  filter: brightness(1.3);
  position: absolute;
  height: 25%;
  top: 50%;
  left: 50%;
  transition: transform 0.1s linear;
  user-select: none;

  ${({ angle }) =>
    angle === 0 &&
    css`
      animation: ${breathe} 1s infinite ease-in-out;
    `}
`;

export const Engranaje = styled.img.attrs(({ angle }) => ({
  style: {
    transform: `translate(-50%, 25%) rotate(${angle}deg)`,
  },
}))`
  position: absolute;
  height: 16%;
  top: 49%; /* Centra verticalmente */
  left: 50%; /* Centra horizontalmente */
  transition: transform 0.1s linear;
`;


const vibrate = keyframes`
  0% { transform: rotate(0deg); }
  25% { transform: rotate(-1deg); }
  50% { transform: rotate(1deg); }
  75% { transform: rotate(-1deg); }
  100% { transform: rotate(1deg); }
`;

export const Notify = styled.div`
  position: absolute;
  top: 0;
  right: 10%;
  background-color: white;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80vw;
  height: 40px;
  z-index: 9000;
  margin-top: 7vh;
    animation-name: ${vibrate};
    animation-duration: .4s;
    animation-iteration-count: infinite;
`

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translate(10vw, 24vh) scale(0.8);
  }
  80% {
    opacity: 1;
    transform: translate(10vw, 24vh) scale(1);
  }
  100% {
    opacity: 0;
    transform: translate(10vw, 24vh) scale(0.8);
  }
`;

export const GashaBall = styled.img`
  position: absolute;
  height: 11%;
  top: 50%;
  left: 50%;
  transform: translate(10vw, 24vh);
  opacity: 0; /* Inicialmente invisible */
  animation: ${fadeIn} 1.5s ease-out forwards;
`;

const fadeIn2 = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const PrizeContainer = styled.div`
  position: absolute;
  top: 0;
  height: 110vh;
  width: 100vw;
  animation: ${fadeIn2} .3s ease-out forwards;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
    user-select: none;
    pointer-events: none;
`

export const ButtonSelect = styled.div`
  position: absolute;
  background-color: ${props => props.color ? 'rgb(236,110,111)' : 'white'};
  border-radius: 25px;
  width: 60vw;
  height: 50px;
  margin-bottom: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: all;
  bottom: 0%; /* Centra verticalmente */
  left: 50%; /* Centra horizontalmente */
  transform: translate(-50%, -50%); /* Ajusta el centro del elemento */
 
`

export const GashaBallOpen = styled.img`
  position: relative;
  height: 20%;
  opacity: 0.7;
  animation: ${vibrate} 1s ease infinite;
    user-select: none;
    pointer-events: none;
`;
const breatheAnimation = keyframes`
  0%, 100% {
    transform: translateY(1px) scale(1) rotateY(15deg);
  }
  50% {
    transform: translateY(-1px) scale(1.01) rotateY(-15deg);
  }
`;
export const PokeImg = styled.img`
  position: absolute;
  width: 60%;
  animation: ${breatheAnimation} 1.5s ease-in-out infinite;
    user-select: none;
    pointer-events: none;
`;